import { render } from "./PractionerMakeAdminModal.vue?vue&type=template&id=1cf2c8f4"
import script from "./PractionerMakeAdminModal.vue?vue&type=script&lang=js"
export * from "./PractionerMakeAdminModal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__